import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AbstractButtonComponent } from '../abstract-button.component';
import { LineHeightByComponent } from '@df/ui/common/line-height-by.component';
import { Loader1Component } from '../../loader/loader-1.component';
import { CommonModule, NgClass } from '@angular/common';

export const buttonStylesOptions = [
    { key: 'button', title: 'Button' },
    { key: 'button-1', title: 'Button 1' },
    { key: 'button-2', title: 'Button 2' },
    { key: 'text-button', title: 'Text button' }
];

export type TButtonStyles = 'button' | 'button-1' | 'button-2' | 'inlineButton' | 'text-button';

@Component({
    selector: 'button[buttonStyle], a[buttonStyle]',
    templateUrl: './button-style.html',
    styleUrls: ['./button-style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [LineHeightByComponent, Loader1Component, NgClass, CommonModule]
})
export class ButtonStyleComponent extends AbstractButtonComponent {
    @Input()
    buttonStyle: TButtonStyles | undefined | '' = 'button';

    protected variantInputName = 'buttonStyle';
}
